import { View } from './view'

export const Socials = View
